module.exports = __webpack_public_path__ + "img/70ne.5f4ac7c3.svg";